export default __webpack_public_path__ + "static/media/fniris2.802b50d2.png";